<template>
  <v-theme-provider dark>
    <section id="order-search">
      <base-img
        :height="$vuetify.breakpoint.mdAndUp ? 350 : 225"
        :gradient="gradient"
        :src="src"
        color="#45516b"
        flat
        max-width="100%"
        tile
      >
        <v-row
          align="center"
          class="ma-0 fill-height text-center"
          justify="center"
        >
          <v-col
            cols="12"
            md="8"
          >
            <v-text-field
              v-model="number"
              label="국제 특송 조회"
              append-icon="mdi-magnify"
              hint="운송장번호 입력해주세요"
              placeholder="운송장번호 입력해주세요"
              onkeyup="value=value.replace(/[^\w\.\/]/ig,'')"
              :outlined="true"
              :single-line="false"
              :clearable="true"
              :persistent-hint="false"
              :loading="loading"
              :dense="false"
              @keyup.enter.native="search"
              @click:append="search"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </base-img>
      <v-row
        align="center"
        class="ma-0 fill-height text-center"
        justify="center"
      >
        <v-col
          cols="12"
          md="8"
        >
          <v-timeline align-top :dense="true">
            <v-timeline-item
              v-for="(item, i) in list"
              :key="i"
              :small="True"
              fill-dot
              icon-color="#fff"
            >
              <template v-slot:icon>
                <v-avatar>
                  <img :src="require('@/assets/icon-'+item.icon+'.png')" style="background: #fff; width: 40px; height: 40px;">
                </v-avatar>
              </template>
              <v-card
                light
                :color="i == 0 ? (item.tag ? '#E91E63' : '#4CAF50') : ''"
                class="elevation-12"
              >
                <v-card-title style="padding: 5px 20px 0px 20px;text-align: left; font-weight: 600; font-size: 14px;">{{item.time}}</v-card-title>
                <v-card-text style="padding: 0px 20px 10px 20px;text-align: left; font-weight: 600">{{item.status}}</v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-col>
      </v-row>

      <v-snackbar
        v-model="snackbar"
        color="error"
        :timeout="timeout"
        :top="true"
      >
        {{ errtext }}

        <template v-slot:action="{ attrs }">
          <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </section>
  </v-theme-provider>
</template>

<script>
import {
  searchInfo
} from '@/api/site'
// Components
import {
  HexToRGBA,
  RGBAtoCSS
} from 'vuetify/lib/util/colorUtils'

export default {
  name: 'SectionOrderSearch',

  metaInfo() {
    return {
      changed: meta => (this.title = meta.titleChunk.toUpperCase())
    }
  },
  provide: {
    heading: { align: 'center' }
  },
  data: () => ({
    True: true,
    number: '',
    errtext: '',
    timeout: 3000,
    loading: false,
    snackbar: false,
    list: []
  }),
  computed: {
    gradient() {
      const color = `${this.$vuetify.theme.themes.light.secondary}CC`
      const overlay = RGBAtoCSS(HexToRGBA(color))
      return `to top, ${overlay}, ${overlay}`
    },
    src() {
      return this.$route.meta.src
    },
    items() {
      return [
        { text: 'HOME', to: '/' },
        { text: this.title }
      ]
    }
  },
  methods: {
    search() {
      const number = this.number
      if (number === '') {
        this.errtext = '운송장 입력해주세요'
        this.snackbar = true
        return
      }
      if (number.indexOf('L') !== 0) {
        this.errtext = '조회된 데이터가 없습니다.운송장이 등록되지 않았거나 업체에서 상품을 준비중입니다.'
        this.snackbar = true
        return
      }
      if (number.length < 8 || number.length > 16) {
        this.errtext = '조회된 데이터가 없습니다.운송장이 등록되지 않았거나 업체에서 상품을 준비중입니다.'
        this.snackbar = true
        return
      }
      this.loading = true
      searchInfo(number).then(response => {
        const data = response.data
        this.list = data.list
        this.list = this.list.map((v, i) => {
          if (i == 0) {
            this.$set(v, 'tag', data.status == 2)
          } else {
            this.$set(v, 'tag', false)
          }
          return v
        })
        console.log(data)
      }).catch(err => {
        this.errtext = err
        this.snackbar = true
        this.list = []
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="sass">
  #hero-alt
    .v-breadcrumbs__item
      color: #FFFFFF
</style>
